import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Container, Form } from "react-bootstrap";
import moment from "moment";
import { useEffect, useState } from "react";

function Forecast({ setForecast, fselectedDate, setMapLeadDate }) {
  const [selectedLead, setSelectedLead] = useState(1);
  const [selectedDate, setSelectedDate] = useState(fselectedDate);
  useEffect(() => {
    setSelectedDate(fselectedDate);
    setSelectedLead(1);
  }, [fselectedDate]);

  useEffect(() => {
    setMapLeadDate(
      moment(fselectedDate)
        .add(selectedLead - 1, "days")
        .format("YYYY-MM-DD")
    );
    setSelectedDate(
      moment(fselectedDate)
        .add(selectedLead - 1, "days")
        .format("YYYY-MM-DD")
    );
  }, [selectedLead, fselectedDate]);

  const handleLeadClick = (lead) => {
    setSelectedLead(lead);
  };

  return (
    <Container fluid className="Forecast">
      <Row>
        <h5>Forecast for</h5>
      </Row>
      <Card className="Forecast_card">
        <Card.Body>
          <Container className="Forecast_card_body">
            <Row xs={1} md={3} className="Forecast_btngrid">
              {Array.from({ length: 7 }).map((_, idx) => (
                <Col className="Forecast_button" key={idx}>
                  <Button
                    className="Forecast_btn"
                    variant="light"
                    onClick={() => {
                      setForecast(idx + 1);
                      handleLeadClick(idx + 1);
                    }}
                    active={selectedLead === idx + 1}
                  >
                    Lead {idx + 1}
                  </Button>
                </Col>
              ))}
            </Row>
          </Container>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default Forecast;
